module.exports = "/_next/static/images/b97b0057bc109cda3700e1447ccea175-cartao-proximo-ao-olho-lg@1x.jpg.webp";